
define('jst!lib/_submit_toggler',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class="submit-toggle-box">\n  <div class="box">\n    <label class="submit-toggler-toggle tooltip" title="<%= translations.tooltip %>" data-tooltip-gravity="s">\n    <input type="checkbox" <%= isEnabled ? \'checked\' : \'\' %>>\n      <div class="toggle-icon sprite-icon <%= isEnabled ? \'icon-16-green-enter\' : \'icon-16-black-enter\' %>"></div>\n    </label>\n    <%- button(submitButtonOptions.label, \'#\', submitButtonOptions) %>\n  </div>\n</div>\n');
 });

